"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientAuthStrategy = void 0;
const axios_1 = __importDefault(require("axios"));
class ClientAuthStrategy {
    constructor(options) {
        this.clientId = options.clientId;
        this.authServiceUrl = options.authServiceUrl.replace(/^\/|\/$/g, '');
    }
    async getToken() {
        try {
            const { data } = await axios_1.default.get(`${this.authServiceUrl}/api/account/token?clientId=${this.clientId}`, {
                withCredentials: true
            });
            return data.token;
        }
        catch (e) {
            console.error(e);
            return null;
        }
    }
}
exports.ClientAuthStrategy = ClientAuthStrategy;
